var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFilePond',{ref:"pond",attrs:{"name":"file","label-idle":"Drag and drop or click here to upload a screenshot or PDF...","credits":"false","allow-multiple":false,"accepted-file-types":"image/jpeg, image/png, application/pdf"},on:{"processfile":_vm.processFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }